import { inherits as _inherits, createClass as _createClass, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../_virtual/_rollupPluginBabelHelpers.mjs';
import { jsx } from 'react/jsx-runtime';
import React__default from 'react';
import styled, { css } from 'styled-components';
import cx from 'classnames';
import TransitionController from '../components/transitionController.mjs';
import { getPaddingStyle } from '../helper/blockitStyleHelpers.mjs';
import { BlockitFeedback } from '../components/feedback/index.mjs';
import { getColorByAlias, px2rem, MEDIA_QUERY, ErrorBoundary } from '@moim/common';

var PlacementContainer = styled.div.withConfig({
  displayName: "PlacementContainer",
  componentId: "sc-1qkw2mx-0"
})(["width:100%;display:flex;align-items:center;justify-content:center;position:relative;", ""], function (props) {
  var _a;
  switch ((_a = props.background) === null || _a === void 0 ? void 0 : _a.type) {
    case "image":
      {
        return css(["background-image:url(", ");background-size:", ";background-repeat:no-repeat;background-position:center;"], props.background.value, props.background.crop === false ? "contain" : "cover");
      }
    case "color":
      {
        return css(["background-color:", ";"], getColorByAlias(props.theme.colorV2, props.background.value));
      }
  }
});
var Section = styled.div.withConfig({
  displayName: "Section",
  componentId: "sc-1qkw2mx-1"
})(["position:relative;max-width:", ";min-width:", ";width:", ";display:flex;flex-direction:column;align-items:center;justify-content:center;@media ", "{width:100%;}", ";"], function (props) {
  return props.sectionMaxWidth ? typeof props.sectionMaxWidth === "number" ? px2rem(props.sectionMaxWidth) : props.sectionMaxWidth : "initial";
}, function (props) {
  return props.sectionMinWidth ? typeof props.sectionMinWidth === "number" ? px2rem(props.sectionMinWidth) : props.sectionMinWidth : "initial";
}, function (props) {
  if (!props.sectionWidth || props.sectionWidth === "fit-container") {
    return "100%";
  }
  return "".concat(props.sectionWidth, "%");
}, MEDIA_QUERY.ONLY_MOBILE, function (props) {
  return getPaddingStyle(props.padding);
});
function withPlacement(WrappedComponent) {
  return /*#__PURE__*/function (_React$PureComponent) {
    function _class() {
      _classCallCheck(this, _class);
      return _callSuper(this, _class, arguments);
    }
    _inherits(_class, _React$PureComponent);
    return _createClass(_class, [{
      key: "render",
      value: function render() {
        var _this = this;
        return jsx(ErrorBoundary, {
          displayErrorMessage: jsx(BlockitFeedback.Empty, {
            textKey: "error"
          }),
          children: jsx(PlacementContainer, {
            background: this.props.background,
            children: jsx(TransitionController, {
              transition: this.props.transition,
              children: function children(_ref) {
                var styles = _ref.styles,
                  animationClassName = _ref.className;
                return jsx(Section, {
                  className: cx(_this.props.className, animationClassName),
                  sectionWidth: _this.props.sectionWidth,
                  sectionMinWidth: _this.props.sectionMinWidth,
                  sectionMaxWidth: _this.props.sectionMaxWidth,
                  padding: _this.props.padding,
                  style: styles,
                  children: jsx(WrappedComponent, Object.assign({}, _this.props))
                });
              }
            })
          })
        });
      }
    }]);
  }(React__default.PureComponent);
}

export { withPlacement };
